export const AUTH_START = 'AUTH_START';
export const AUTH_RESET = 'AUTH_RESET';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTO_AUTH_DONE = 'AUTO_AUTH_DONE';
export const NAME_CHANGE = 'NAME_CHANGE';
